import { createSlice } from "@reduxjs/toolkit";

const initialProvinsiState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  provinsiForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const provinsiSlice = createSlice({
  name: "provinsi",
  initialState: initialProvinsiState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    provinsiFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    provinsiAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    provinsiCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.provinsi.push(action.payload.provinsi);
    },
    provinsiDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.provinsi.filter(
        (el) => el.provinsi_id !== action.payload.id
      );
    },
    getProvinsi: (state, action) => {
      state.actionsLoading = false;
      state.provinsiForEdit = action.payload.provinsiForEdit;
      state.error = null;
    },
    // updateProduct
    provinsiUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.provinsi = state.entities.provinsi.map((entity) => {
        if (entity.provinsi_id === action.payload.provinsi.provinsi_id) {
          return action.payload.provinsi;
        }
        return entity;
      });
    },
  },
});
